"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/** @module geotiffimage */

var float16_1 = require("@petamoriken/float16");

var get_attribute_js_1 = __importDefault(require("xml-utils/get-attribute.js"));

var find_tags_by_name_js_1 = __importDefault(require("xml-utils/find-tags-by-name.js"));

var globals_js_1 = require("./globals.js");

var rgb_js_1 = require("./rgb.js");

var index_js_1 = require("./compression/index.js");

var resample_js_1 = require("./resample.js");
/**
 * @typedef {Object} ReadRasterOptions
 * @property {Array<number>} [window=whole window] the subset to read data from in pixels.
 * @property {Array<number>} [bbox=whole image] the subset to read data from in
 *                                           geographical coordinates.
 * @property {Array<number>} [samples=all samples] the selection of samples to read from. Default is all samples.
 * @property {boolean} [interleave=false] whether the data shall be read
 *                                             in one single array or separate
 *                                             arrays.
 * @property {Pool} [pool=null] The optional decoder pool to use.
 * @property {number} [width] The desired width of the output. When the width is not the
 *                                 same as the images, resampling will be performed.
 * @property {number} [height] The desired height of the output. When the width is not the
 *                                  same as the images, resampling will be performed.
 * @property {string} [resampleMethod='nearest'] The desired resampling method.
 * @property {AbortSignal} [signal] An AbortSignal that may be signalled if the request is
 *                                       to be aborted
 * @property {number|number[]} [fillValue] The value to use for parts of the image
 *                                              outside of the images extent. When multiple
 *                                              samples are requested, an array of fill values
 *                                              can be passed.
 */

/** @typedef {import("./geotiff.js").TypedArray} TypedArray */

/** @typedef {import("./geotiff.js").ReadRasterResult} ReadRasterResult */


function sum(array, start, end) {
  var s = 0;

  for (var i = start; i < end; ++i) {
    s += array[i];
  }

  return s;
}

function arrayForType(format, bitsPerSample, size) {
  switch (format) {
    case 1:
      // unsigned integer data
      if (bitsPerSample <= 8) {
        return new Uint8Array(size);
      } else if (bitsPerSample <= 16) {
        return new Uint16Array(size);
      } else if (bitsPerSample <= 32) {
        return new Uint32Array(size);
      }

      break;

    case 2:
      // twos complement signed integer data
      if (bitsPerSample === 8) {
        return new Int8Array(size);
      } else if (bitsPerSample === 16) {
        return new Int16Array(size);
      } else if (bitsPerSample === 32) {
        return new Int32Array(size);
      }

      break;

    case 3:
      // floating point data
      switch (bitsPerSample) {
        case 16:
        case 32:
          return new Float32Array(size);

        case 64:
          return new Float64Array(size);

        default:
          break;
      }

      break;

    default:
      break;
  }

  throw Error('Unsupported data format/bitsPerSample');
}

function needsNormalization(format, bitsPerSample) {
  if ((format === 1 || format === 2) && bitsPerSample <= 32 && bitsPerSample % 8 === 0) {
    return false;
  } else if (format === 3 && (bitsPerSample === 16 || bitsPerSample === 32 || bitsPerSample === 64)) {
    return false;
  }

  return true;
}

function normalizeArray(inBuffer, format, planarConfiguration, samplesPerPixel, bitsPerSample, tileWidth, tileHeight) {
  // const inByteArray = new Uint8Array(inBuffer);
  var view = new DataView(inBuffer);
  var outSize = planarConfiguration === 2 ? tileHeight * tileWidth : tileHeight * tileWidth * samplesPerPixel;
  var samplesToTransfer = planarConfiguration === 2 ? 1 : samplesPerPixel;
  var outArray = arrayForType(format, bitsPerSample, outSize); // let pixel = 0;

  var bitMask = parseInt('1'.repeat(bitsPerSample), 2);

  if (format === 1) {
    // unsigned integer
    // translation of https://github.com/OSGeo/gdal/blob/master/gdal/frmts/gtiff/geotiff.cpp#L7337
    var pixelBitSkip; // let sampleBitOffset = 0;

    if (planarConfiguration === 1) {
      pixelBitSkip = samplesPerPixel * bitsPerSample; // sampleBitOffset = (samplesPerPixel - 1) * bitsPerSample;
    } else {
      pixelBitSkip = bitsPerSample;
    } // Bits per line rounds up to next byte boundary.


    var bitsPerLine = tileWidth * pixelBitSkip;

    if ((bitsPerLine & 7) !== 0) {
      bitsPerLine = bitsPerLine + 7 & ~7;
    }

    for (var y = 0; y < tileHeight; ++y) {
      var lineBitOffset = y * bitsPerLine;

      for (var x = 0; x < tileWidth; ++x) {
        var pixelBitOffset = lineBitOffset + x * samplesToTransfer * bitsPerSample;

        for (var i = 0; i < samplesToTransfer; ++i) {
          var bitOffset = pixelBitOffset + i * bitsPerSample;
          var outIndex = (y * tileWidth + x) * samplesToTransfer + i;
          var byteOffset = Math.floor(bitOffset / 8);
          var innerBitOffset = bitOffset % 8;

          if (innerBitOffset + bitsPerSample <= 8) {
            outArray[outIndex] = view.getUint8(byteOffset) >> 8 - bitsPerSample - innerBitOffset & bitMask;
          } else if (innerBitOffset + bitsPerSample <= 16) {
            outArray[outIndex] = view.getUint16(byteOffset) >> 16 - bitsPerSample - innerBitOffset & bitMask;
          } else if (innerBitOffset + bitsPerSample <= 24) {
            var raw = view.getUint16(byteOffset) << 8 | view.getUint8(byteOffset + 2);
            outArray[outIndex] = raw >> 24 - bitsPerSample - innerBitOffset & bitMask;
          } else {
            outArray[outIndex] = view.getUint32(byteOffset) >> 32 - bitsPerSample - innerBitOffset & bitMask;
          } // let outWord = 0;
          // for (let bit = 0; bit < bitsPerSample; ++bit) {
          //   if (inByteArray[bitOffset >> 3]
          //     & (0x80 >> (bitOffset & 7))) {
          //     outWord |= (1 << (bitsPerSample - 1 - bit));
          //   }
          //   ++bitOffset;
          // }
          // outArray[outIndex] = outWord;
          // outArray[pixel] = outWord;
          // pixel += 1;

        } // bitOffset = bitOffset + pixelBitSkip - bitsPerSample;

      }
    }
  } else if (format === 3) {// floating point
    // Float16 is handled elsewhere
    // normalize 16/24 bit floats to 32 bit floats in the array
    // console.time();
    // if (bitsPerSample === 16) {
    //   for (let byte = 0, outIndex = 0; byte < inBuffer.byteLength; byte += 2, ++outIndex) {
    //     outArray[outIndex] = getFloat16(view, byte);
    //   }
    // }
    // console.timeEnd()
  }

  return outArray.buffer;
}
/**
 * GeoTIFF sub-file image.
 */


var GeoTIFFImage = /*#__PURE__*/function () {
  /**
   * @constructor
   * @param {Object} fileDirectory The parsed file directory
   * @param {Object} geoKeys The parsed geo-keys
   * @param {DataView} dataView The DataView for the underlying file.
   * @param {Boolean} littleEndian Whether the file is encoded in little or big endian
   * @param {Boolean} cache Whether or not decoded tiles shall be cached
   * @param {import('./source/basesource').BaseSource} source The datasource to read from
   */
  function GeoTIFFImage(fileDirectory, geoKeys, dataView, littleEndian, cache, source) {
    (0, _classCallCheck2.default)(this, GeoTIFFImage);
    this.fileDirectory = fileDirectory;
    this.geoKeys = geoKeys;
    this.dataView = dataView;
    this.littleEndian = littleEndian;
    this.tiles = cache ? {} : null;
    this.isTiled = !fileDirectory.StripOffsets;
    var planarConfiguration = fileDirectory.PlanarConfiguration;
    this.planarConfiguration = typeof planarConfiguration === 'undefined' ? 1 : planarConfiguration;

    if (this.planarConfiguration !== 1 && this.planarConfiguration !== 2) {
      throw new Error('Invalid planar configuration.');
    }

    this.source = source;
  }
  /**
   * Returns the associated parsed file directory.
   * @returns {Object} the parsed file directory
   */


  (0, _createClass2.default)(GeoTIFFImage, [{
    key: "getFileDirectory",
    value: function getFileDirectory() {
      return this.fileDirectory;
    }
    /**
     * Returns the associated parsed geo keys.
     * @returns {Object} the parsed geo keys
     */

  }, {
    key: "getGeoKeys",
    value: function getGeoKeys() {
      return this.geoKeys;
    }
    /**
     * Returns the width of the image.
     * @returns {Number} the width of the image
     */

  }, {
    key: "getWidth",
    value: function getWidth() {
      return this.fileDirectory.ImageWidth;
    }
    /**
     * Returns the height of the image.
     * @returns {Number} the height of the image
     */

  }, {
    key: "getHeight",
    value: function getHeight() {
      return this.fileDirectory.ImageLength;
    }
    /**
     * Returns the number of samples per pixel.
     * @returns {Number} the number of samples per pixel
     */

  }, {
    key: "getSamplesPerPixel",
    value: function getSamplesPerPixel() {
      return typeof this.fileDirectory.SamplesPerPixel !== 'undefined' ? this.fileDirectory.SamplesPerPixel : 1;
    }
    /**
     * Returns the width of each tile.
     * @returns {Number} the width of each tile
     */

  }, {
    key: "getTileWidth",
    value: function getTileWidth() {
      return this.isTiled ? this.fileDirectory.TileWidth : this.getWidth();
    }
    /**
     * Returns the height of each tile.
     * @returns {Number} the height of each tile
     */

  }, {
    key: "getTileHeight",
    value: function getTileHeight() {
      if (this.isTiled) {
        return this.fileDirectory.TileLength;
      }

      if (typeof this.fileDirectory.RowsPerStrip !== 'undefined') {
        return Math.min(this.fileDirectory.RowsPerStrip, this.getHeight());
      }

      return this.getHeight();
    }
  }, {
    key: "getBlockWidth",
    value: function getBlockWidth() {
      return this.getTileWidth();
    }
  }, {
    key: "getBlockHeight",
    value: function getBlockHeight(y) {
      if (this.isTiled || (y + 1) * this.getTileHeight() <= this.getHeight()) {
        return this.getTileHeight();
      } else {
        return this.getHeight() - y * this.getTileHeight();
      }
    }
    /**
     * Calculates the number of bytes for each pixel across all samples. Only full
     * bytes are supported, an exception is thrown when this is not the case.
     * @returns {Number} the bytes per pixel
     */

  }, {
    key: "getBytesPerPixel",
    value: function getBytesPerPixel() {
      var bytes = 0;

      for (var i = 0; i < this.fileDirectory.BitsPerSample.length; ++i) {
        bytes += this.getSampleByteSize(i);
      }

      return bytes;
    }
  }, {
    key: "getSampleByteSize",
    value: function getSampleByteSize(i) {
      if (i >= this.fileDirectory.BitsPerSample.length) {
        throw new RangeError("Sample index ".concat(i, " is out of range."));
      }

      return Math.ceil(this.fileDirectory.BitsPerSample[i] / 8);
    }
  }, {
    key: "getReaderForSample",
    value: function getReaderForSample(sampleIndex) {
      var format = this.fileDirectory.SampleFormat ? this.fileDirectory.SampleFormat[sampleIndex] : 1;
      var bitsPerSample = this.fileDirectory.BitsPerSample[sampleIndex];

      switch (format) {
        case 1:
          // unsigned integer data
          if (bitsPerSample <= 8) {
            return DataView.prototype.getUint8;
          } else if (bitsPerSample <= 16) {
            return DataView.prototype.getUint16;
          } else if (bitsPerSample <= 32) {
            return DataView.prototype.getUint32;
          }

          break;

        case 2:
          // twos complement signed integer data
          if (bitsPerSample <= 8) {
            return DataView.prototype.getInt8;
          } else if (bitsPerSample <= 16) {
            return DataView.prototype.getInt16;
          } else if (bitsPerSample <= 32) {
            return DataView.prototype.getInt32;
          }

          break;

        case 3:
          switch (bitsPerSample) {
            case 16:
              return function (offset, littleEndian) {
                return (0, float16_1.getFloat16)(this, offset, littleEndian);
              };

            case 32:
              return DataView.prototype.getFloat32;

            case 64:
              return DataView.prototype.getFloat64;

            default:
              break;
          }

          break;

        default:
          break;
      }

      throw Error('Unsupported data format/bitsPerSample');
    }
  }, {
    key: "getSampleFormat",
    value: function getSampleFormat() {
      var sampleIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      return this.fileDirectory.SampleFormat ? this.fileDirectory.SampleFormat[sampleIndex] : 1;
    }
  }, {
    key: "getBitsPerSample",
    value: function getBitsPerSample() {
      var sampleIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      return this.fileDirectory.BitsPerSample[sampleIndex];
    }
  }, {
    key: "getArrayForSample",
    value: function getArrayForSample(sampleIndex, size) {
      var format = this.getSampleFormat(sampleIndex);
      var bitsPerSample = this.getBitsPerSample(sampleIndex);
      return arrayForType(format, bitsPerSample, size);
    }
    /**
     * Returns the decoded strip or tile.
     * @param {Number} x the strip or tile x-offset
     * @param {Number} y the tile y-offset (0 for stripped images)
     * @param {Number} sample the sample to get for separated samples
     * @param {import("./geotiff").Pool|import("./geotiff").BaseDecoder} poolOrDecoder the decoder or decoder pool
     * @param {AbortSignal} [signal] An AbortSignal that may be signalled if the request is
     *                               to be aborted
     * @returns {Promise.<ArrayBuffer>}
     */

  }, {
    key: "getTileOrStrip",
    value: function () {
      var _getTileOrStrip = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(x, y, sample, poolOrDecoder, signal) {
        var _this = this;

        var numTilesPerRow, numTilesPerCol, index, tiles, offset, byteCount, slice, request;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                numTilesPerRow = Math.ceil(this.getWidth() / this.getTileWidth());
                numTilesPerCol = Math.ceil(this.getHeight() / this.getTileHeight());
                tiles = this.tiles;

                if (this.planarConfiguration === 1) {
                  index = y * numTilesPerRow + x;
                } else if (this.planarConfiguration === 2) {
                  index = sample * numTilesPerRow * numTilesPerCol + y * numTilesPerRow + x;
                }

                if (this.isTiled) {
                  offset = this.fileDirectory.TileOffsets[index];
                  byteCount = this.fileDirectory.TileByteCounts[index];
                } else {
                  offset = this.fileDirectory.StripOffsets[index];
                  byteCount = this.fileDirectory.StripByteCounts[index];
                }

                _context2.next = 7;
                return this.source.fetch([{
                  offset: offset,
                  length: byteCount
                }], signal);

              case 7:
                slice = _context2.sent[0];

                if (tiles === null || !tiles[index]) {
                  // resolve each request by potentially applying array normalization
                  request = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
                    var data, sampleFormat, bitsPerSample;
                    return _regenerator.default.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.next = 2;
                            return poolOrDecoder.decode(_this.fileDirectory, slice);

                          case 2:
                            data = _context.sent;
                            sampleFormat = _this.getSampleFormat();
                            bitsPerSample = _this.getBitsPerSample();

                            if (needsNormalization(sampleFormat, bitsPerSample)) {
                              data = normalizeArray(data, sampleFormat, _this.planarConfiguration, _this.getSamplesPerPixel(), bitsPerSample, _this.getTileWidth(), _this.getBlockHeight(y));
                            }

                            return _context.abrupt("return", data);

                          case 7:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }))(); // set the cache

                  if (tiles !== null) {
                    tiles[index] = request;
                  }
                } else {
                  // get from the cache
                  request = tiles[index];
                } // cache the tile request


                _context2.t0 = x;
                _context2.t1 = y;
                _context2.t2 = sample;
                _context2.next = 14;
                return request;

              case 14:
                _context2.t3 = _context2.sent;
                return _context2.abrupt("return", {
                  x: _context2.t0,
                  y: _context2.t1,
                  sample: _context2.t2,
                  data: _context2.t3
                });

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getTileOrStrip(_x, _x2, _x3, _x4, _x5) {
        return _getTileOrStrip.apply(this, arguments);
      }

      return getTileOrStrip;
    }()
    /**
     * Internal read function.
     * @private
     * @param {Array} imageWindow The image window in pixel coordinates
     * @param {Array} samples The selected samples (0-based indices)
     * @param {TypedArray|TypedArray[]} valueArrays The array(s) to write into
     * @param {Boolean} interleave Whether or not to write in an interleaved manner
     * @param {import("./geotiff").Pool|AbstractDecoder} poolOrDecoder the decoder or decoder pool
     * @param {number} width the width of window to be read into
     * @param {number} height the height of window to be read into
     * @param {number} resampleMethod the resampling method to be used when interpolating
     * @param {AbortSignal} [signal] An AbortSignal that may be signalled if the request is
     *                               to be aborted
     * @returns {Promise<ReadRasterResult>}
     */

  }, {
    key: "_readRaster",
    value: function () {
      var _readRaster2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(imageWindow, samples, valueArrays, interleave, poolOrDecoder, width, height, resampleMethod, signal) {
        var _this2 = this;

        var tileWidth, tileHeight, imageWidth, imageHeight, minXTile, maxXTile, minYTile, maxYTile, windowWidth, bytesPerPixel, srcSampleOffsets, sampleReaders, i, promises, littleEndian, yTile, xTile, _loop, sampleIndex, resampled;

        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                tileWidth = this.getTileWidth();
                tileHeight = this.getTileHeight();
                imageWidth = this.getWidth();
                imageHeight = this.getHeight();
                minXTile = Math.max(Math.floor(imageWindow[0] / tileWidth), 0);
                maxXTile = Math.min(Math.ceil(imageWindow[2] / tileWidth), Math.ceil(imageWidth / tileWidth));
                minYTile = Math.max(Math.floor(imageWindow[1] / tileHeight), 0);
                maxYTile = Math.min(Math.ceil(imageWindow[3] / tileHeight), Math.ceil(imageHeight / tileHeight));
                windowWidth = imageWindow[2] - imageWindow[0];
                bytesPerPixel = this.getBytesPerPixel();
                srcSampleOffsets = [];
                sampleReaders = [];

                for (i = 0; i < samples.length; ++i) {
                  if (this.planarConfiguration === 1) {
                    srcSampleOffsets.push(sum(this.fileDirectory.BitsPerSample, 0, samples[i]) / 8);
                  } else {
                    srcSampleOffsets.push(0);
                  }

                  sampleReaders.push(this.getReaderForSample(samples[i]));
                }

                promises = [];
                littleEndian = this.littleEndian;

                for (yTile = minYTile; yTile < maxYTile; ++yTile) {
                  for (xTile = minXTile; xTile < maxXTile; ++xTile) {
                    _loop = function _loop(sampleIndex) {
                      var si = sampleIndex;
                      var sample = samples[sampleIndex];

                      if (_this2.planarConfiguration === 2) {
                        bytesPerPixel = _this2.getSampleByteSize(sampleIndex);
                      }

                      var promise = _this2.getTileOrStrip(xTile, yTile, sample, poolOrDecoder, signal).then(function (tile) {
                        var buffer = tile.data;
                        var dataView = new DataView(buffer);

                        var blockHeight = _this2.getBlockHeight(tile.y);

                        var firstLine = tile.y * tileHeight;
                        var firstCol = tile.x * tileWidth;
                        var lastLine = firstLine + blockHeight;
                        var lastCol = (tile.x + 1) * tileWidth;
                        var reader = sampleReaders[si];
                        var ymax = Math.min(blockHeight, blockHeight - (lastLine - imageWindow[3]), imageHeight - firstLine);
                        var xmax = Math.min(tileWidth, tileWidth - (lastCol - imageWindow[2]), imageWidth - firstCol);

                        for (var y = Math.max(0, imageWindow[1] - firstLine); y < ymax; ++y) {
                          for (var x = Math.max(0, imageWindow[0] - firstCol); x < xmax; ++x) {
                            var pixelOffset = (y * tileWidth + x) * bytesPerPixel;
                            var value = reader.call(dataView, pixelOffset + srcSampleOffsets[si], littleEndian);
                            var windowCoordinate = void 0;

                            if (interleave) {
                              windowCoordinate = (y + firstLine - imageWindow[1]) * windowWidth * samples.length + (x + firstCol - imageWindow[0]) * samples.length + si;
                              valueArrays[windowCoordinate] = value;
                            } else {
                              windowCoordinate = (y + firstLine - imageWindow[1]) * windowWidth + x + firstCol - imageWindow[0];
                              valueArrays[si][windowCoordinate] = value;
                            }
                          }
                        }
                      });

                      promises.push(promise);
                    };

                    for (sampleIndex = 0; sampleIndex < samples.length; ++sampleIndex) {
                      _loop(sampleIndex);
                    }
                  }
                }

                _context3.next = 18;
                return Promise.all(promises);

              case 18:
                if (!(width && imageWindow[2] - imageWindow[0] !== width || height && imageWindow[3] - imageWindow[1] !== height)) {
                  _context3.next = 23;
                  break;
                }

                if (interleave) {
                  resampled = (0, resample_js_1.resampleInterleaved)(valueArrays, imageWindow[2] - imageWindow[0], imageWindow[3] - imageWindow[1], width, height, samples.length, resampleMethod);
                } else {
                  resampled = (0, resample_js_1.resample)(valueArrays, imageWindow[2] - imageWindow[0], imageWindow[3] - imageWindow[1], width, height, resampleMethod);
                }

                resampled.width = width;
                resampled.height = height;
                return _context3.abrupt("return", resampled);

              case 23:
                valueArrays.width = width || imageWindow[2] - imageWindow[0];
                valueArrays.height = height || imageWindow[3] - imageWindow[1];
                return _context3.abrupt("return", valueArrays);

              case 26:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function _readRaster(_x6, _x7, _x8, _x9, _x10, _x11, _x12, _x13, _x14) {
        return _readRaster2.apply(this, arguments);
      }

      return _readRaster;
    }()
    /**
     * Reads raster data from the image. This function reads all selected samples
     * into separate arrays of the correct type for that sample or into a single
     * combined array when `interleave` is set. When provided, only a subset
     * of the raster is read for each sample.
     *
     * @param {ReadRasterOptions} [options={}] optional parameters
     * @returns {Promise<ReadRasterResult>} the decoded arrays as a promise
     */

  }, {
    key: "readRasters",
    value: function () {
      var _readRasters = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
        var _ref2,
            wnd,
            _ref2$samples,
            samples,
            interleave,
            _ref2$pool,
            pool,
            width,
            height,
            resampleMethod,
            fillValue,
            signal,
            imageWindow,
            imageWindowWidth,
            imageWindowHeight,
            numPixels,
            samplesPerPixel,
            i,
            _i,
            valueArrays,
            format,
            bitsPerSample,
            _i2,
            valueArray,
            poolOrDecoder,
            result,
            _args4 = arguments;

        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _ref2 = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {}, wnd = _ref2.window, _ref2$samples = _ref2.samples, samples = _ref2$samples === void 0 ? [] : _ref2$samples, interleave = _ref2.interleave, _ref2$pool = _ref2.pool, pool = _ref2$pool === void 0 ? null : _ref2$pool, width = _ref2.width, height = _ref2.height, resampleMethod = _ref2.resampleMethod, fillValue = _ref2.fillValue, signal = _ref2.signal;
                imageWindow = wnd || [0, 0, this.getWidth(), this.getHeight()]; // check parameters

                if (!(imageWindow[0] > imageWindow[2] || imageWindow[1] > imageWindow[3])) {
                  _context4.next = 4;
                  break;
                }

                throw new Error('Invalid subsets');

              case 4:
                imageWindowWidth = imageWindow[2] - imageWindow[0];
                imageWindowHeight = imageWindow[3] - imageWindow[1];
                numPixels = imageWindowWidth * imageWindowHeight;
                samplesPerPixel = this.getSamplesPerPixel();

                if (!(!samples || !samples.length)) {
                  _context4.next = 12;
                  break;
                }

                for (i = 0; i < samplesPerPixel; ++i) {
                  samples.push(i);
                }

                _context4.next = 19;
                break;

              case 12:
                _i = 0;

              case 13:
                if (!(_i < samples.length)) {
                  _context4.next = 19;
                  break;
                }

                if (!(samples[_i] >= samplesPerPixel)) {
                  _context4.next = 16;
                  break;
                }

                return _context4.abrupt("return", Promise.reject(new RangeError("Invalid sample index '".concat(samples[_i], "'."))));

              case 16:
                ++_i;
                _context4.next = 13;
                break;

              case 19:
                if (interleave) {
                  format = this.fileDirectory.SampleFormat ? Math.max.apply(null, this.fileDirectory.SampleFormat) : 1;
                  bitsPerSample = Math.max.apply(null, this.fileDirectory.BitsPerSample);
                  valueArrays = arrayForType(format, bitsPerSample, numPixels * samples.length);

                  if (fillValue) {
                    valueArrays.fill(fillValue);
                  }
                } else {
                  valueArrays = [];

                  for (_i2 = 0; _i2 < samples.length; ++_i2) {
                    valueArray = this.getArrayForSample(samples[_i2], numPixels);

                    if (Array.isArray(fillValue) && _i2 < fillValue.length) {
                      valueArray.fill(fillValue[_i2]);
                    } else if (fillValue && !Array.isArray(fillValue)) {
                      valueArray.fill(fillValue);
                    }

                    valueArrays.push(valueArray);
                  }
                }

                _context4.t0 = pool;

                if (_context4.t0) {
                  _context4.next = 25;
                  break;
                }

                _context4.next = 24;
                return (0, index_js_1.getDecoder)(this.fileDirectory);

              case 24:
                _context4.t0 = _context4.sent;

              case 25:
                poolOrDecoder = _context4.t0;
                _context4.next = 28;
                return this._readRaster(imageWindow, samples, valueArrays, interleave, poolOrDecoder, width, height, resampleMethod, signal);

              case 28:
                result = _context4.sent;
                return _context4.abrupt("return", result);

              case 30:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function readRasters() {
        return _readRasters.apply(this, arguments);
      }

      return readRasters;
    }()
    /**
     * Reads raster data from the image as RGB. The result is always an
     * interleaved typed array.
     * Colorspaces other than RGB will be transformed to RGB, color maps expanded.
     * When no other method is applicable, the first sample is used to produce a
     * grayscale image.
     * When provided, only a subset of the raster is read for each sample.
     *
     * @param {Object} [options] optional parameters
     * @param {Array<number>} [options.window] the subset to read data from in pixels.
     * @param {boolean} [options.interleave=true] whether the data shall be read
     *                                             in one single array or separate
     *                                             arrays.
     * @param {import("./geotiff").Pool} [options.pool=null] The optional decoder pool to use.
     * @param {number} [options.width] The desired width of the output. When the width is no the
     *                                 same as the images, resampling will be performed.
     * @param {number} [options.height] The desired height of the output. When the width is no the
     *                                  same as the images, resampling will be performed.
     * @param {string} [options.resampleMethod='nearest'] The desired resampling method.
     * @param {boolean} [options.enableAlpha=false] Enable reading alpha channel if present.
     * @param {AbortSignal} [options.signal] An AbortSignal that may be signalled if the request is
     *                                       to be aborted
     * @returns {Promise<ReadRasterResult>} the RGB array as a Promise
     */

  }, {
    key: "readRGB",
    value: function () {
      var _readRGB = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5() {
        var _ref3,
            window,
            _ref3$interleave,
            interleave,
            _ref3$pool,
            pool,
            width,
            height,
            resampleMethod,
            _ref3$enableAlpha,
            enableAlpha,
            signal,
            imageWindow,
            pi,
            s,
            i,
            samples,
            subOptions,
            fileDirectory,
            raster,
            max,
            data,
            red,
            green,
            blue,
            j,
            _args5 = arguments;

        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _ref3 = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : {}, window = _ref3.window, _ref3$interleave = _ref3.interleave, interleave = _ref3$interleave === void 0 ? true : _ref3$interleave, _ref3$pool = _ref3.pool, pool = _ref3$pool === void 0 ? null : _ref3$pool, width = _ref3.width, height = _ref3.height, resampleMethod = _ref3.resampleMethod, _ref3$enableAlpha = _ref3.enableAlpha, enableAlpha = _ref3$enableAlpha === void 0 ? false : _ref3$enableAlpha, signal = _ref3.signal;
                imageWindow = window || [0, 0, this.getWidth(), this.getHeight()]; // check parameters

                if (!(imageWindow[0] > imageWindow[2] || imageWindow[1] > imageWindow[3])) {
                  _context5.next = 4;
                  break;
                }

                throw new Error('Invalid subsets');

              case 4:
                pi = this.fileDirectory.PhotometricInterpretation;

                if (!(pi === globals_js_1.photometricInterpretations.RGB)) {
                  _context5.next = 9;
                  break;
                }

                s = [0, 1, 2];

                if (!(this.fileDirectory.ExtraSamples === globals_js_1.ExtraSamplesValues.Unspecified) && enableAlpha) {
                  s = [];

                  for (i = 0; i < this.fileDirectory.BitsPerSample.length; i += 1) {
                    s.push(i);
                  }
                }

                return _context5.abrupt("return", this.readRasters({
                  window: window,
                  interleave: interleave,
                  samples: s,
                  pool: pool,
                  width: width,
                  height: height,
                  resampleMethod: resampleMethod,
                  signal: signal
                }));

              case 9:
                _context5.t0 = pi;
                _context5.next = _context5.t0 === globals_js_1.photometricInterpretations.WhiteIsZero ? 12 : _context5.t0 === globals_js_1.photometricInterpretations.BlackIsZero ? 12 : _context5.t0 === globals_js_1.photometricInterpretations.Palette ? 12 : _context5.t0 === globals_js_1.photometricInterpretations.CMYK ? 14 : _context5.t0 === globals_js_1.photometricInterpretations.YCbCr ? 16 : _context5.t0 === globals_js_1.photometricInterpretations.CIELab ? 16 : 18;
                break;

              case 12:
                samples = [0];
                return _context5.abrupt("break", 19);

              case 14:
                samples = [0, 1, 2, 3];
                return _context5.abrupt("break", 19);

              case 16:
                samples = [0, 1, 2];
                return _context5.abrupt("break", 19);

              case 18:
                throw new Error('Invalid or unsupported photometric interpretation.');

              case 19:
                subOptions = {
                  window: imageWindow,
                  interleave: true,
                  samples: samples,
                  pool: pool,
                  width: width,
                  height: height,
                  resampleMethod: resampleMethod,
                  signal: signal
                };
                fileDirectory = this.fileDirectory;
                _context5.next = 23;
                return this.readRasters(subOptions);

              case 23:
                raster = _context5.sent;
                max = Math.pow(2, this.fileDirectory.BitsPerSample[0]);
                _context5.t1 = pi;
                _context5.next = _context5.t1 === globals_js_1.photometricInterpretations.WhiteIsZero ? 28 : _context5.t1 === globals_js_1.photometricInterpretations.BlackIsZero ? 30 : _context5.t1 === globals_js_1.photometricInterpretations.Palette ? 32 : _context5.t1 === globals_js_1.photometricInterpretations.CMYK ? 34 : _context5.t1 === globals_js_1.photometricInterpretations.YCbCr ? 36 : _context5.t1 === globals_js_1.photometricInterpretations.CIELab ? 38 : 40;
                break;

              case 28:
                data = (0, rgb_js_1.fromWhiteIsZero)(raster, max);
                return _context5.abrupt("break", 41);

              case 30:
                data = (0, rgb_js_1.fromBlackIsZero)(raster, max);
                return _context5.abrupt("break", 41);

              case 32:
                data = (0, rgb_js_1.fromPalette)(raster, fileDirectory.ColorMap);
                return _context5.abrupt("break", 41);

              case 34:
                data = (0, rgb_js_1.fromCMYK)(raster);
                return _context5.abrupt("break", 41);

              case 36:
                data = (0, rgb_js_1.fromYCbCr)(raster);
                return _context5.abrupt("break", 41);

              case 38:
                data = (0, rgb_js_1.fromCIELab)(raster);
                return _context5.abrupt("break", 41);

              case 40:
                throw new Error('Unsupported photometric interpretation.');

              case 41:
                // if non-interleaved data is requested, we must split the channels
                // into their respective arrays
                if (!interleave) {
                  red = new Uint8Array(data.length / 3);
                  green = new Uint8Array(data.length / 3);
                  blue = new Uint8Array(data.length / 3);

                  for (i = 0, j = 0; i < data.length; i += 3, ++j) {
                    red[j] = data[i];
                    green[j] = data[i + 1];
                    blue[j] = data[i + 2];
                  }

                  data = [red, green, blue];
                }

                data.width = raster.width;
                data.height = raster.height;
                return _context5.abrupt("return", data);

              case 45:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function readRGB() {
        return _readRGB.apply(this, arguments);
      }

      return readRGB;
    }()
    /**
     * Returns an array of tiepoints.
     * @returns {Object[]}
     */

  }, {
    key: "getTiePoints",
    value: function getTiePoints() {
      if (!this.fileDirectory.ModelTiepoint) {
        return [];
      }

      var tiePoints = [];

      for (var i = 0; i < this.fileDirectory.ModelTiepoint.length; i += 6) {
        tiePoints.push({
          i: this.fileDirectory.ModelTiepoint[i],
          j: this.fileDirectory.ModelTiepoint[i + 1],
          k: this.fileDirectory.ModelTiepoint[i + 2],
          x: this.fileDirectory.ModelTiepoint[i + 3],
          y: this.fileDirectory.ModelTiepoint[i + 4],
          z: this.fileDirectory.ModelTiepoint[i + 5]
        });
      }

      return tiePoints;
    }
    /**
     * Returns the parsed GDAL metadata items.
     *
     * If sample is passed to null, dataset-level metadata will be returned.
     * Otherwise only metadata specific to the provided sample will be returned.
     *
     * @param {number} [sample=null] The sample index.
     * @returns {Object}
     */

  }, {
    key: "getGDALMetadata",
    value: function getGDALMetadata() {
      var sample = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var metadata = {};

      if (!this.fileDirectory.GDAL_METADATA) {
        return null;
      }

      var string = this.fileDirectory.GDAL_METADATA;
      var items = (0, find_tags_by_name_js_1.default)(string, 'Item');

      if (sample === null) {
        items = items.filter(function (item) {
          return (0, get_attribute_js_1.default)(item, 'sample') === undefined;
        });
      } else {
        items = items.filter(function (item) {
          return Number((0, get_attribute_js_1.default)(item, 'sample')) === sample;
        });
      }

      for (var i = 0; i < items.length; ++i) {
        var item = items[i];
        metadata[(0, get_attribute_js_1.default)(item, 'name')] = item.inner;
      }

      return metadata;
    }
    /**
     * Returns the GDAL nodata value
     * @returns {number|null}
     */

  }, {
    key: "getGDALNoData",
    value: function getGDALNoData() {
      if (!this.fileDirectory.GDAL_NODATA) {
        return null;
      }

      var string = this.fileDirectory.GDAL_NODATA;
      return Number(string.substring(0, string.length - 1));
    }
    /**
     * Returns the image origin as a XYZ-vector. When the image has no affine
     * transformation, then an exception is thrown.
     * @returns {Array<number>} The origin as a vector
     */

  }, {
    key: "getOrigin",
    value: function getOrigin() {
      var tiePoints = this.fileDirectory.ModelTiepoint;
      var modelTransformation = this.fileDirectory.ModelTransformation;

      if (tiePoints && tiePoints.length === 6) {
        return [tiePoints[3], tiePoints[4], tiePoints[5]];
      }

      if (modelTransformation) {
        return [modelTransformation[3], modelTransformation[7], modelTransformation[11]];
      }

      throw new Error('The image does not have an affine transformation.');
    }
    /**
     * Returns the image resolution as a XYZ-vector. When the image has no affine
     * transformation, then an exception is thrown.
     * @param {GeoTIFFImage} [referenceImage=null] A reference image to calculate the resolution from
     *                                             in cases when the current image does not have the
     *                                             required tags on its own.
     * @returns {Array<number>} The resolution as a vector
     */

  }, {
    key: "getResolution",
    value: function getResolution() {
      var referenceImage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var modelPixelScale = this.fileDirectory.ModelPixelScale;
      var modelTransformation = this.fileDirectory.ModelTransformation;

      if (modelPixelScale) {
        return [modelPixelScale[0], -modelPixelScale[1], modelPixelScale[2]];
      }

      if (modelTransformation) {
        return [modelTransformation[0], modelTransformation[5], modelTransformation[10]];
      }

      if (referenceImage) {
        var _referenceImage$getRe = referenceImage.getResolution(),
            _referenceImage$getRe2 = (0, _slicedToArray2.default)(_referenceImage$getRe, 3),
            refResX = _referenceImage$getRe2[0],
            refResY = _referenceImage$getRe2[1],
            refResZ = _referenceImage$getRe2[2];

        return [refResX * referenceImage.getWidth() / this.getWidth(), refResY * referenceImage.getHeight() / this.getHeight(), refResZ * referenceImage.getWidth() / this.getWidth()];
      }

      throw new Error('The image does not have an affine transformation.');
    }
    /**
     * Returns whether or not the pixels of the image depict an area (or point).
     * @returns {Boolean} Whether the pixels are a point
     */

  }, {
    key: "pixelIsArea",
    value: function pixelIsArea() {
      return this.geoKeys.GTRasterTypeGeoKey === 1;
    }
    /**
     * Returns the image bounding box as an array of 4 values: min-x, min-y,
     * max-x and max-y. When the image has no affine transformation, then an
     * exception is thrown.
     * @returns {Array<number>} The bounding box
     */

  }, {
    key: "getBoundingBox",
    value: function getBoundingBox() {
      var origin = this.getOrigin();
      var resolution = this.getResolution();
      var x1 = origin[0];
      var y1 = origin[1];
      var x2 = x1 + resolution[0] * this.getWidth();
      var y2 = y1 + resolution[1] * this.getHeight();
      return [Math.min(x1, x2), Math.min(y1, y2), Math.max(x1, x2), Math.max(y1, y2)];
    }
  }]);
  return GeoTIFFImage;
}();

exports.default = GeoTIFFImage;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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